/**
 * Only display children if we're in the snap mode.
 */

import { useDeviceType } from "@/common/hooks/useDeviceType";
import { useAppStore } from "@/common/store/appStore";
import { useFeedV2Store } from "@/common/store/useFeedV2Store";
import { deviceTypeEnum } from "@/common/utils/device";
import { useMemo } from "react";

interface IProps {
  children: React.ReactNode;
}

export const SnapOnly = ({ children }: IProps) => {
  const isFullScreen = useAppStore((state) => state.isFullScreen);
  const isV2Variant = useFeedV2Store((state) => state.isV2Variant);
  const snapFeedDisabled = useFeedV2Store((state) => state.snapFeedDisabled);
  const isMobile = useDeviceType() === deviceTypeEnum.PHONE;
  const snapAvailable = useMemo(() => isMobile && !snapFeedDisabled && isV2Variant, [isMobile, snapFeedDisabled, isV2Variant]);

  if (snapAvailable || isFullScreen) {
    return <>{children}</>;
  }

  return null;
};
